export enum StatusCabecalhoPedidoDeCarga {
  Calculado = 0,
  Verificado = 1,
  FalhaNaComunicacaoAPI = 2,
  PedidoComCriticaAPI = 3,
  PedidoRealizadoAPI = 4,
  PedidoRealizadoArquivoGerado = 5,
  PedidoCancelado = 9,
}
